import { CloseButton, Text, VStack } from "@chakra-ui/react"

import { Dialog } from "@chakra-ui/react"
import { useState } from "react"
import { ArchiveButton } from "@hydrologiq/shared/content/components/Button"
import { ActionButton } from "@hydrologiq/shared/content/components/ActionButton"
import { ArchiveCustomerDocument } from "@hydrologiq/gql/graphql"
import { useMutation } from "@apollo/client"
import { useCopyValues } from "@hydrologiq/shared/providers/helpers/useCopy"
import { COPY_KEYS, DEFAULT_COPY_MAPPINGS } from "@hydrologiq/shared/copy/constants"
import { Customer } from "@hydrologiq/gql-experience/graphql"
import { useArchiveCustomer } from "../../providers/helpers/useCustomer"

export const CustomerArchive = ({ customer }: { customer?: Customer | undefined }) => {
  const [open, setOpen] = useState(false)

  const [archiveCustomer] = useMutation(ArchiveCustomerDocument)
  const archive = useArchiveCustomer()
  const [loading, setLoading] = useState(false)

  const copy = useCopyValues({
    [COPY_KEYS.BUTTONS.ARCHIVE]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.ARCHIVE],
    [COPY_KEYS.BUTTONS.CANCEL]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.BUTTONS.CANCEL],
    [COPY_KEYS.HEADINGS.CUSTOMER]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.CUSTOMER],
    [COPY_KEYS.HEADINGS.SITE]: DEFAULT_COPY_MAPPINGS[COPY_KEYS.HEADINGS.SITE],
  })

  const onArchive = () => {
    if (customer?.id) {
      setLoading(true)
      archiveCustomer({ variables: { id: customer.id } })
        .then(() => {
          archive()
          setLoading(false)
          setOpen(false)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }

  return (
    <Dialog.Root lazyMount open={open} onOpenChange={(e) => setOpen(e.open)}>
      <Dialog.Trigger>
        <ArchiveButton disabled={!customer} />
      </Dialog.Trigger>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header>
            <Dialog.Title>{copy[COPY_KEYS.HEADINGS.CUSTOMER]} deletion</Dialog.Title>
          </Dialog.Header>
          <Dialog.Body>
            <VStack alignItems={"flex-start"} gap={2}>
              <Text>
                {customer?.name} will no longer be available to use in Hydrologiq and all{" "}
                {copy[COPY_KEYS.HEADINGS.SITE].toLowerCase()} associations will be removed.
              </Text>
              <Text>This cannot be undone. Are you sure?</Text>
            </VStack>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.ActionTrigger asChild>
              <ActionButton
                disabled={loading}
                context={{
                  label: copy[COPY_KEYS.BUTTONS.ARCHIVE],
                  description: `${copy[COPY_KEYS.BUTTONS.ARCHIVE]} the current ${copy[
                    COPY_KEYS.HEADINGS.CUSTOMER
                  ].toLowerCase()}`,
                  variant: "secondary",
                }}
                onClick={onArchive}
              />
            </Dialog.ActionTrigger>
            <ActionButton
              disabled={loading}
              onClick={() => setOpen(false)}
              context={{
                label: copy[COPY_KEYS.BUTTONS.CANCEL],
                description: `Do not ${copy[COPY_KEYS.BUTTONS.ARCHIVE].toLowerCase()} the current ${copy[
                  COPY_KEYS.HEADINGS.CUSTOMER
                ].toLowerCase()}`,
                variant: "primary",
              }}
            />
          </Dialog.Footer>
          <Dialog.CloseTrigger disabled={loading} asChild>
            <CloseButton size="sm" />
          </Dialog.CloseTrigger>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  )
}
